export default __webpack_public_path__ + "static/media/newpizza.045fb5d7.png";